import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import getCookie from '../utils/cookieUtils';
import {attemptTokenRefresh} from "./refreshToken";
import { setErrorMessage } from '../services/403Error/errorSlice';

const baseQuery = fetchBaseQuery({
    baseUrl: '',
    credentials: 'include',
    prepareHeaders: (headers) => {
        const token = getCookie('token');
        if (token) {
            headers.set('Authorization', `Bearer ${token}`);
        }
        return headers;
    }
});

export const baseQueryWithReauth = async (args, api, extraOptions) => {
    let result = await baseQuery(args, api, extraOptions);

    if (result.error?.status === 401) {
        try {
            await attemptTokenRefresh();
            // Retry original request with new token in cookie
            result = await baseQuery(args, api, extraOptions);
        } catch {
            // logout is handled inside attemptTokenRefresh
        }
    }

    // 403 surfacing — mirrors apiClient's behavior so RTK Query mutations
    // don't fail silently when the user lacks permission.
    if (result.error?.status === 403) {
        api.dispatch(setErrorMessage('Du har ikke tilgang til å utføre denne handlingen.'));
    }

    return result;
};